/**
 * 从刊登任务详情提取店铺 / 类目 / 产品模板，供商品库与第三方 meta 回填。
 */

function firstText(...values) {
  for (const value of values) {
    const text = String(value ?? '').trim();
    if (text) return text;
  }
  return '';
}

/**
 * @param {object} jobDetail getListingJob / createListingJob 返回
 * @returns {{ listingShopId: string, listingShopName: string, listingCategoryPathLabel: string, listingProductTemplateId: string, listingProductTemplateName: string }}
 */
export function listingInfoPatchFromJob(jobDetail) {
  if (!jobDetail || typeof jobDetail !== 'object') {
    return {
      listingShopId: '',
      listingShopName: '',
      listingCategoryPathLabel: '',
      listingProductTemplateId: '',
      listingProductTemplateName: '',
    };
  }
  const shopId = jobDetail.shopId ?? jobDetail.shop_id;
  return {
    listingShopId: shopId != null && String(shopId).trim() !== '' ? String(shopId) : '',
    listingShopName: firstText(jobDetail.shopName, jobDetail.shop_name),
    listingCategoryPathLabel: firstText(jobDetail.categoryPathLabel, jobDetail.category_path_label),
    listingProductTemplateId: firstText(jobDetail.productTemplateId, jobDetail.product_template_id),
    listingProductTemplateName: firstText(jobDetail.productTemplateName, jobDetail.product_template_name),
  };
}

/**
 * 空位补全：已有本地值优先，任务详情补缺。
 * @param {object} [prev]
 * @param {object} [fromJob]
 */
export function mergeListingInfoFields(prev = {}, fromJob = {}) {
  return {
    listingShopId: firstText(prev.listingShopId, fromJob.listingShopId),
    listingShopName: firstText(prev.listingShopName, fromJob.listingShopName),
    listingCategoryPathLabel: firstText(prev.listingCategoryPathLabel, fromJob.listingCategoryPathLabel),
    listingProductTemplateId: firstText(prev.listingProductTemplateId, fromJob.listingProductTemplateId),
    listingProductTemplateName: firstText(prev.listingProductTemplateName, fromJob.listingProductTemplateName),
  };
}

export function needsListingInfoBackfill(meta = {}) {
  return !firstText(meta.listingShopName)
    || !firstText(meta.listingCategoryPathLabel)
    || !firstText(meta.listingProductTemplateName);
}
